import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import PropTypes from 'prop-types';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Service from './services';
import { PaginationTotal } from '../../../commons/controls';
import Lib from '../../../commons/lib';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { selectFilter, textFilter } from 'react-bootstrap-table2-filter';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import ProgressButton from '../../../commons/ProgressButton';

class PenznemLista extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalForm: false,
      modalNezet: false,
      modalTorles: false,
      dataLoaded: false,
      dataFailed: false,
      penznemLista: [],
      penznem: {},
      statusz: [],
      statuszOptions: [],
      filterOptions: {},
      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
    };
  }

  componentDidMount() {
    this.updateTable();
  }

  updateTable = () => {
    this.setState({
      dataLoaded: false, dataFailed: false, penznemLista: []
    });
    Service.listPenznem((err, res) => {
      if (err) {
        this.setState({ dataFailed: true });
      } else {
        let filters = {};
        let options = res[0].statusz.map((e) => {
          filters[e.name] = e.caption;

          return <option key={e.name} value={e.name}>{e.caption}</option>;
        });

        this.setState({
          penznemLista: res[0].list,
          statusz: res[0].statusz,
          statuszOptions: options,
          filterOptions: filters,
          dataLoaded: true,
          dataFailed: false,
          penznem: {}
        });
      }
    });
  }

  toggleForm = (updateTable, insert) => {
    if (insert)
      this.setState({ penznem: {} });
    this.setState({ modalForm: !this.state.modalForm }, () => {
      if (updateTable && typeof updateTable === 'function') updateTable();
    });
  }

  toggleTorles = () => {
    this.setState({ modalTorles: !this.state.modalTorles });
  }

  toggleNezet = () => {
    this.setState({ modalNezet: !this.state.modalNezet });
  }

  handleCancel = () => {
    this.setState({ modalForm: !this.state.modalForm }, () => {
      this.updateTable();
    });
  }

  handleEditClick = (id) => {
    Service.getPenznem(id, (err, res) => {
      if (!err) {
        let obj = res[0];
        // obj.aktiv = obj.aktiv ? 'Aktív' : 'Inaktív';
        obj.tizedesjegy = obj.tizedesjegy === 0 ? '0' : obj.tizedesjegy;
        this.setState({ penznem: obj }, () => { this.toggleForm(); });
      }
    });
  }

  handleDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleTorles();
  }

  handleViewClick = (id) => {
    this._currentViewId = id;
    this.toggleNezet();
  }

  iconFormatter = (cell) => {
    return (
      <div>
        {
          this.props.globals.hasRole(['PENZUGYKOZOS_PENZNEM'], true) && (
            <React.Fragment>
              <Button className="icon-pencil table-action-icon" id={'action-edit-' + cell} onClick={() => this.handleEditClick(cell)} />
              <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-edit-' + cell} delay={10}>
                {'Módosítás'}
              </UncontrolledTooltip>
              <Button className="icon-trash table-action-icon" id={'action-delete-' + cell} onClick={() => this.handleDeleteClick(cell)} />
              <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-delete-' + cell} delay={10}>
                {'Törlés'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
      </div>
    );
  }

  /**
  * Visszaadja az apartmanhoz tartozó státus jelvényeket.
  * @param {boolean} cell - Cella adatot tartalmazó szöveg.
  * @return {ReactElement} Státusz jelvényt tartalmazó react objektum.
  */
  statusFormatter = (cell) => {
    let statusz = this.state.statusz.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  defaultCurrencyFormatter = (cell) => {
    return <span className={'badge badge-' + (cell ? 'success' : 'default')}>{cell ? 'Igen' : 'Nem'}</span>;
  }

  savePenznem = (event, submitObj) => {
    let obj = { ...submitObj }
    obj.defaultcurrency = obj.defaultcurrency || false;
    if (RegExp('[^0-9]').test(obj.tizedesjegy)) {
      this.props.globals.addError("A tizedesjegy pontossága csak természetes szám lehet!");
    } else {
      if (this.state.penznem && !this.state.penznem.id) {
        this.insert(obj);
      } else {
        obj.id = this.state.penznem.id;
        this.edit(obj);
      }
    }
  }

  insert = (obj) => {
    this.setState({ addButtonLoading: true });
    Service.addPenznem(obj, (err) => {
      if (!err) {
        this.toggleForm(() => this.updateTable());
        this.props.globals.addSuccess('Pénznem hozzáadva!');
      }
      this.setState({ addButtonLoading: false });
    });
  }


  edit = (obj) => {
    this.setState({ modifyButtonLoading: true });
    Service.editPenznem(obj, (err) => {
      if (!err) {
        this.toggleForm(() => this.updateTable());
        this.props.globals.addSuccess('Pénznem módosítva!');
      }
      this.setState({ modifyButtonLoading: false });
    });
  }

  deletePenznem = (id) => {
    this.toggleTorles();
    this.setState({ deleteButtonLoading: true });
    Service.deletePenznem(id, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Pénznem törölve!');
      }
      this.setState({ deleteButtonLoading: false });
    });
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    let defaultCurrencyFilterOptions = [
      { value: true, label: 'Igen' },
      { value: false, label: 'Nem' }
    ];

    const columns = [
      {
        dataField: 'azonosito',
        text: 'Pénznem ISO kódja',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'nev',
        text: 'Pénznem neve',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'jel',
        text: 'Pénznem jele',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'statusz',
        text: 'Státusz',
        formatter: this.statusFormatter,
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
          condition: 'eq'
        }),
        align: 'center'
      },
      {
        dataField: 'defaultCurrency',
        text: 'Alapértelmezett',
        formatter: this.defaultCurrencyFormatter,
        filter: selectFilter({
          options: defaultCurrencyFilterOptions,
          placeholder: 'Összes',
          condition: 'eq'
        }),
        align: 'center'
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter,
        hidden: !this.props.globals.hasRole(['PENZUGYKOZOS_PENZNEM'], true)
      },
    ];

    return (
      this.state.penznemLista.length ?
        <BootstrapTable
          bootstrap4
          keyField="id"
          columns={columns}
          data={this.state.penznemLista}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
        />
        : <DataEmptyState />);
  }

  renderLoader = () => {
    return (
      <div className="showbox">
        <div className="loader">
          <svg className="circular" viewBox="25 25 50 50">
            <circle className="path" cx="50" cy="50" r="20" fill="none" />
          </svg>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {
          this.props.globals.hasRole(['PENZUGYKOZOS_PENZNEM'], true) &&
          (
          <div className="row">
            <div className="col-sm-12">
              <Button className="pull-left table-new-button" color="primary" onClick={() => this.toggleForm(null, true)}>Új pénznem</Button>
            </div>
          </div>
        )}
        {(this.state.dataLoaded && !this.state.dataFailed) ? this.renderTable() : (this.state.dataFailed) ? <NetworkEmptyState submitClick={this.updateTable} /> : this.renderLoader()}
        <Modal isOpen={this.state.modalTorles} toggle={this.toggleTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>
            {'Valóban törölni kívánod a kiválasztott tételt?'}
          </ModalBody>
          <ModalFooter>
            <ProgressButton className="btn-cursor-pointer" color="primary" loading={this.state.deleteButtonLoading} onClick={() => this.deletePenznem(this._currentDeleteId)}>OK</ProgressButton>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalForm} toggle={this.toggleForm} className={this.props.className} backdrop="static" >
          <RFForm
            modal
            onSubmit={this.savePenznem}
            title={!this.state.penznem.id ? 'Új pénznem rögzítése' : 'Pénznem módosítása'}
            footer={
              <>
                <ProgressButton color="primary" loading={!this.state.penznem.id ? this.state.addButtonLoading : this.state.modifyButtonLoading}>Mentés</ProgressButton>{' '}
                <Button type="button" color="secondary" onClick={this.handleCancel} >Mégsem</Button>
              </>
            }
          >
            <RFField
              label="Pénznem ISO kódja: *"
              name="azonosito"
              value={this.state.penznem.azonosito}
              disabled={this.state.penznem.id}
              required={!this.state.penznem.id}
              maxLength="3"
            />
            <RFField
              label="Pénznem neve: *"
              name="nev"
              value={this.state.penznem.nev}
              required
              maxLength="50"
            />
            <RFField
              label="Pénznem jele: *"
              name="jel"
              value={this.state.penznem.jel}
              required
              maxLength="4"
            />
            <RFField
              label="Tizedesjegy pontosság: *"
              name="tizedesjegy"
              numberOnlyWhole
              value={this.state.penznem.tizedesjegy}
              required
            />
            <div className="row">
              <div className="col-sm-8">
                <RFField
                  type="select"
                  name="statusz"
                  label="Státusz: *"
                  value={this.state.penznem.statusz}
                  required
                  defaultSelect={<option value="" disabled >Válassz státuszt...</option>}
                  selectOptions={this.state.statuszOptions}
                />
              </div>
              <div className="col-sm-4">
                <div className="row" style={{ paddingTop: '35px' }}>
                  <RFField
                    label="Alapértelmezett"
                    type="checkbox"
                    name="defaultcurrency"
                    value={!!this.state.penznem.defaultcurrency}
                  />
                  <div style={{paddingLeft: '7px'}}></div>
                </div>
              </div>
            </div>
          </RFForm>
        </Modal>
      </div>
    );
  }
}

PenznemLista.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object,
  className: PropTypes.string,
};

export default PenznemLista;
